<template lang="pug">
  #popup-menu.popup__main
    .popup__header
      //- a(href="#" @click.prevent="closePopup").popup__close
    .popup__content
      nav.popup__list
        ul
          li
            a(href="/" @click.prevent="goToHomePage") #[span 首頁]
          li
            a(href="https://mkp.taishinbank.com.tw/s/2023/conscientious/index.html#/more" @click="$trackEvent('menu', 'click_button', 'menu_more');" target="_blank") #[span 看更多認真故事]
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mixins } from '@/utils/mixins'

export default {
  name: 'PopupMenu',
  mixins: [mixins],
  props: {
  },
  data: () => {
    return {
    }
  },
  computed: {
    ...mapState(['popup']),
  },
  methods: {
    ...mapActions(['closePopup']),
    goToHomePage() {
      const { closePopup, isProduction } = this;
      if (isProduction()) {
        this.$trackEvent('menu', 'click_button', 'menu_index', function() {
          location.href = `${process.env.VUE_APP_LOGO_LINK}`;
        });
      } else {
        closePopup();
        if (this.$route.path !== '/') this.$router.push('/');
        this.$trackEvent('menu', 'click_button', 'menu_index');
      }
      // setTimeout(() => {
      //   location.href = '/';
      // }, 500);
    },
  },
  mounted() {
    this.$trackPage('menu');
  },
  components: {
  }
}
</script>

<style lang="scss">

#popup-menu {

  a {
    color: #fff;
  }

  .popup__list {

    li {

      &::after {
        content: '';
        display: block;
        width: vw(210);
        height: vw(1);
        margin: vw(40) auto;
        background: #d70c1a;
      }

      &:last-child::after {
        content: none;
      }

    }

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: vw(72);
      font-size: vw(30);
      font-weight: 500;
      letter-spacing: vw(letterSpacing(260, 30));
    }

    span {
      transform-origin: center top;
      transform: scaleX(.95);
    }

  }

}

</style>
